module.exports = __webpack_public_path__ + "static/media/nibbs-logo.eeaab583.png";